/**
 * The layout route element for the five sales screens — a `ToastProvider` around
 * an `Outlet`, and deliberately nothing else.
 *
 * WHY IT IS NOT IN `routes.tsx`. `routes.tsx` is route METADATA, the shape
 * `features/admin/routes.infra.tsx` and `features/admin/routes.users.tsx` both
 * keep: one `RouteObject[]` export and no component declarations. Declaring a
 * component in that file alongside the array breaks React Fast Refresh for the
 * module — an edit to the array would remount the provider and drop whatever
 * toast was on screen — and `react-refresh/only-export-components` says so
 * ("Move your component(s) to a separate file"). So the component lives here,
 * next to the other component modules in this folder (`money.tsx`, `states.tsx`,
 * `status.tsx`), and `routes.tsx` goes back to being a list of paths.
 *
 * The rationale for there being ONE provider for all five routes, rather than one
 * per page, stays with the routes in `routes.tsx`: it is a fact about the route
 * tree, not about this component.
 */

import { Outlet } from 'react-router-dom';
import { ToastProvider } from '../inquiries/toast';

export function QuoteProviders(): React.JSX.Element {
  return (
    <ToastProvider>
      <Outlet />
    </ToastProvider>
  );
}
